import { useParameter, useService } from 'contexts';
import { IPotluck } from 'interfaces';
import { useEffect, useState } from 'react';

export const usePotluck = () => {
  const { potluckService } = useService();
  const { params, token } = useParameter<{ id: string }>();

  const [potluck, setPotluck] = useState<IPotluck | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (params.id) {
        const response = await potluckService.findById(params.id);
        setPotluck(response);
      }
    };
    fetchData();
  }, [params.id]);

  return { potluck, token };
};